<template>
  <v-stepper
    v-model="step"
    class="transparent elevation-0">
    <v-stepper-header
      class="d-flex flex-nowrap">
      <v-stepper-step
        :complete="step > 1"
        :complete-icon="null"
        :edit-icon="null"
        :error-icon="null"
        data-step="1"
        :color="step === 1 ? 'primary' : 'border'"
        step="1"
        :class="{
          'invoice-paramater-stepper font-weight-bold ui-text-md': true,
          'foreground--text': step > 1
        }">
        <span
          :class="{
            'foreground--text': step === 1,
            'foreground--text font-weight-regular': step > 1
          }">
          Selecione um nível
        </span>
      </v-stepper-step>

      <v-divider />

      <v-stepper-step
        :complete="step > 2"
        :complete-icon="null"
        :edit-icon="null"
        :error-icon="null"
        data-step="2"
        step="2"
        class="invoice-paramater-stepper pr-0 font-weight-bold ui-text-md">
        <span
          :class="{
            'foreground--text': step === 2,
            'foreground--text font-weight-regular': step != 2
          }">
          Configurar Parâmetro
        </span>
      </v-stepper-step>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'InvoiceStepper',
  computed: {
    ...mapGetters({
      step: 'invoice-parameter/invoiceParameterStep',
    }),
  },
}
</script>

<style lang="scss">
.invoice-paramater-stepper.v-stepper__step--complete .v-stepper__step__step .v-icon {
  display: none !important;
}
.invoice-paramater-stepper {
  position: relative;
}
.invoice-paramater-stepper.v-stepper__step--complete::after {
  content: attr(data-step);
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(100%, -50%);
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1;
  pointer-events: none;
}

</style>